const { fetchJSON } = window.BAO.Utils

class StoreSelectorModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* Force redirect - Start */
    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    }
    /* Force redirect - End */

    this.dismissedKey = 'BAO-selector-dismissed'

    this.formEl = this.els.form.element

    if (!this.formEl) return

    this.setupListeners()

    if (this.isDismissed()) return

    if (this.noLocationStored) {
      this.forceRedirect()
    }
  }

  setupListeners () {
    this.handleCountryChange = this.handleCountryChange.bind(this)
    this.handleLanguageChange = this.handleLanguageChange.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onDismissClick = this.onDismissClick.bind(this)

    this.listeners.add(this.els.countrySelect.element, 'change', (e) => {
      this.handleCountryChange(e)
    })

    this.listeners.add(this.els.languageSelect.element, 'change', (e) => {
      this.handleLanguageChange(e)
    })

    this.listeners.add(this.els.trigger.element, 'click', () => {
      this.onTriggerClick()
    })

    const closeButton = document
      .querySelector('[data-site-modal-key="store-selector-modal"]')
      .querySelectorAll('[data-site-modal-el="close"]')

    if (closeButton) {
      closeButton.forEach((close) => {
        this.listeners.add(close, `click`, this.onDismissClick)
      })
    }
  }

  forceRedirect () {
    fetchJSON('/browsing_context_suggestions.json', { method: 'GET' }).then(
      (res) => {
        const userCountry = res.detected_values.country.handle
        const currentCountry = this.formEl.querySelector(
          '[name="country_code"]',
        ).value

        if (userCountry !== currentCountry) {
          this.updateCountrySelection(userCountry)
          this.showModal()
        }
      },
    )
  }

  updateCountrySelection (userCountry) {
    const countrySelectEl = this.els.countrySelect.element
    for (const option of countrySelectEl.options) {
      if (option.value === userCountry) {
        option.selected = true
        this.handleCountryChange({ target: countrySelectEl })
        break
      }
    }
  }

  showModal () {
    const modalKey = 'store-selector-modal'
    const modalElement = document.querySelector(
      `site-modal[data-site-modal-key="${modalKey}"]`,
    )

    if (modalElement) {
      document.body.classList.add('util-SiteOverflowed')
      modalElement.setAttribute('aria-hidden', 'false')
    }
  }

  handleCountryChange (e) {
    this.els.countryCode.element.value = e.target.value

    const flagUrl = e.target.options[e.target.selectedIndex].dataset.image
    this.els.countrySelect.element.style.setProperty(
      '--Background_Image',
      `url(${flagUrl})`,
    )

    const languageOptions = Array.from(this.els.languageSelect.element.options)

    const matchingLanguage = languageOptions.find(
      (language) => language.dataset.image === flagUrl,
    )
    if (matchingLanguage) {
      this.els.languageCode.element.value = matchingLanguage.value
      this.els.languageSelect.element.value = matchingLanguage.value

      this.els.languageSelect.element.style.setProperty(
        '--Background_Image',
        `url(${flagUrl})`,
      )
    }
  }

  handleLanguageChange (e) {
    this.els.languageCode.element.value = e.target.value

    const flagUrl = e.target.options[e.target.selectedIndex].dataset.image
    this.els.languageSelect.element.style.setProperty(
      '--Background_Image',
      `url(${flagUrl})`,
    )
  }

  onTriggerClick () {
    this.formEl.submit()

    window.sessionStorage.setItem(
      this.userLocationName,
      this.els.countryCode.element.value,
    )
  }

  hideModal () {
    const modalKey = 'store-selector-modal'
    const modalElement = document.querySelector(
      `site-modal[data-site-modal-key="${modalKey}"]`,
    )

    if (modalElement) {
      modalElement.setAttribute('aria-hidden', 'true')
      document.body.classList.remove('util-SiteOverflowed')
    }
  }

  onDismissClick () {
    const dismissTimestamp = Date.now()
    window.sessionStorage.setItem(this.dismissedKey, dismissTimestamp)

    this.hideModal()
  }

  isDismissed () {
    const dismissTimestamp = window.sessionStorage.getItem(this.dismissedKey)
    if (!dismissTimestamp) return false

    const currentTime = Date.now()
    const threeDays = 3 * 24 * 60 * 60 * 1000
    return currentTime - dismissTimestamp < threeDays
  }

  get noLocationStored () {
    return (
      window.sessionStorage.getItem(this.userLocationName) == null ||
      window.sessionStorage.getItem(this.userLocationName) === undefined
    )
  }

  get userLocationName () {
    return 'BAO-localization-country'
  }
}

if (!customElements.get('store-selector-modal')) {
  customElements.define('store-selector-modal', StoreSelectorModal)
}
